/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCompanyFlexiproductQuery = gql`
  query GetSimulationCompanyFlexiproductQuery($idcc: String) {
    getSimulationCompanyFlexiproduct_simulation_company(idcc: $idcc) {
      ccnHasAgreement 
      agreementIsCompliant 
      isEmptyFlexiproduct 
      error 
    }
  }
`;

export default GetSimulationCompanyFlexiproductQuery;
